"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GridItems_vue_1 = __importDefault(require("./Items/GridItems.vue"));
var ListItems_vue_1 = __importDefault(require("./Items/ListItems.vue"));
var Pagination_vue_1 = __importDefault(require("@/Views/Components/Misc/Pagination.vue"));
var NoItemsBanner_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Index/Items/NoItemsBanner.vue"));
var NotBoardMemberBanner_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Index/Items/NotBoardMemberBanner.vue"));
exports.default = {
    components: {
        NotBoardMemberBanner: NotBoardMemberBanner_vue_1.default,
        NoItemsBanner: NoItemsBanner_vue_1.default,
        Grid: GridItems_vue_1.default,
        List: ListItems_vue_1.default,
        Pagination: Pagination_vue_1.default,
    },
    props: {
        userCanAccessBoard: {
            type: Boolean,
            required: true
        },
        paginatedItems: {
            type: Object,
            required: true
        },
        currentViewValue: {
            type: String,
            required: false
        },
        currentRoute: { required: true, type: Object },
        currentRouteName: { required: true, type: String },
        board: { required: true, type: Object },
        currentParam: { required: true, type: String },
    }
};
